import { message } from 'antd'
import { AppStore, GameLibraryStore } from 'src/pc/store/AppStore'
import { changeWindowStatus } from 'src/pc/store/UIController'
import { CLOUD_GAME_EXIT_TYPE } from 'src/pc/store/cloudGame/cloudGameHelper'
import { DWRecoverControl } from 'src/commons/store/CloudGameStore'
import { isChangshaGJ } from 'src/commons/utils/Commons'
import CloudGameClientStore, { resetMultiplayerStore } from 'src/pc/store/cloudGame/cloudGameClientStore'
import PostMessageController from 'src/pc/store/cloudGame/PostMessageController'
import useCloudGameStart from 'src/pc/components/hooks/useCloudGameStart'

export const FrameOrigins = isChangshaGJ
  ? {
    // dev: 'http://10.13.7.21:9012',
    //todo:长沙管家云游戏页面
    dev: 'http://cloud-game-page.test.steamvipmall.com',
    test: 'http://cloud-game-page.test.steamvipmall.com',
    pre: 'http://cloud-game-page.prd.steamvipmall.com',
    prod: 'https://cloud-game-page.steamvipmall.com',
  }
  : {
    // dev: 'http://10.13.7.21:9012',
    dev: 'http://cloud-game-page.test.99box.com',
    test: 'http://cloud-game-page.test.99box.com',
    pre: 'http://cloud-game-page.prd.99box.com',
    prod: 'https://cloud-game-page.99box.com',
  }

const clientPostMessage = new PostMessageController({ postWin: null, postOrigin: FrameOrigins[process.env.BUILD_TYPE] })

export const initPostMessage = () => {
  /** 切换全屏 */
  clientPostMessage.subscribe('set_full_screen', () => {
    const status = AppStore.windowStatus
    console.debug(
      `%c 接收到云游戏窗口切换全屏请求, current : ${status}  target: ${status === 2 ? 0 : 2}`,
      'font-size:20px;font-weight:bold;color:#7fea2d;',
    )
    changeWindowStatus(status === 2 ? 0 : 2)
  })

  /** 退出游戏 */
  clientPostMessage.subscribe('hide-cloud-game-view', ({ data }) => {
    const { stopCloudGame } = useCloudGameStart()
    stopCloudGame({ needRequest: false, reason: data.reason })
    if (data.code !== CLOUD_GAME_EXIT_TYPE.USER_OPTED_OUT.code) {
      if (data.code === CLOUD_GAME_EXIT_TYPE.SDK_DISCONNECT) {
        setTimeout(() => {
          CloudGameClientStore.cloudGameStartCrash = data
        }, 1000)
      } else {
        CloudGameClientStore.cloudGameStartCrash = data
      }
    }
  })

  /** 云游戏页面加载完成 */
  clientPostMessage.subscribe('cloud_page_load_complete', () => {
    CloudGameClientStore.cloudPageStatus = true
  })

  /** 点击退出游戏 */
  clientPostMessage.subscribe('request-exit', () => {
    CloudGameClientStore.visibleExitConfirmModal = true
  })

  /** 被邀请玩家退出游戏 */
  clientPostMessage.subscribe('player-request-exit', () => {
    CloudGameClientStore.multipleModalStatus = 'player-confirm-exit'
  })

  /** 被邀请玩家端异常断开 */
  clientPostMessage.subscribe('accept-invitation-failed', ({ data: { code, reason } }) => {
    const { hostUserId = '' } = CloudGameClientStore.multiplayerInfo || {}
    if (code === CLOUD_GAME_EXIT_TYPE.CONNECT_SESSION_CREATE_FAILED.code) {
      message.warn(`网络异常,接收云游戏控制权失败`)
    } else if (code === CLOUD_GAME_EXIT_TYPE.SDK_DISCONNECT.code) {
      message.warn(`用户${hostUserId}已主动结束云游戏，您无法再继续玩当前游戏`)
    }
    resetMultiplayerStore()
  })

  /** 邀请玩家 */
  clientPostMessage.subscribe('invite-player', () => {
    CloudGameClientStore.multipleModalStatus = 'invite'
  })

  /** 重新控制 */
  clientPostMessage.subscribe('recover-control-req', () => {
    CloudGameClientStore.multipleModalStatus = 'confirm-recover'
  })

  /** 强制获取控制权 */
  clientPostMessage.subscribe('force-recover', () => {
    const { roomNo, hostUserId, touristsUserId } = CloudGameClientStore.multiplayerInfo || {}
    if (roomNo && hostUserId && touristsUserId) {
      DWRecoverControl.Execute({ roomNo, hostUserId, touristsUserId })
    }
    resetMultiplayerStore()
  })

  /** 同步房间状态信息 */
  clientPostMessage.subscribe('sync-seats-info', ({ data: { seatsInfo } }) => {
    if (CloudGameClientStore.multiplayerInfo) {
      const { players, viewers } = seatsInfo || {}
      CloudGameClientStore.multiplayerInfo.players = players
      CloudGameClientStore.multiplayerInfo.viewers = viewers
    }
  })

  /** 控制权同步 */
  clientPostMessage.subscribe('sync-control', ({ data: { control, subjective } }) => {
    console.log('sync-control', control)
    const { multipleUserRole, multipleHasControl, multiplayerInfo } = CloudGameClientStore
    if (multipleUserRole === 'none') {
      return
    }
    /** 被邀请玩家  控制权被收回时，关闭游戏窗口 */
    if (multipleUserRole === 'player' && multipleHasControl === 'player' && control === 'viewer') {
      if (subjective) {
        message.success(`退出游戏成功，游戏控制权已自动移交${multiplayerInfo?.hostUserId || ''}`)
      } else {
        message.warn(`用户${multiplayerInfo?.hostUserId || ''}已主动收回云游戏控制权，当前游戏已关闭`)
      }
      resetMultiplayerStore()
    } else {
      CloudGameClientStore.multipleHasControl = control
    }
  })
}

export default clientPostMessage
